// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"212269a6","209":"3fe01075","787":"0ed81586"}[chunkId] + ".chunk.js";
};